/**
 * Downloads a file from the given URL to the user's browser.
 *
 * @param {string} fileUrl
 * @param {string} fileName
 * @export
 */
export default function downloadFileUrl(
    fileUrl: string,
    fileName?: string,
): void {
    const link = document.createElement("a");
    document.body.appendChild(link);

    link.href = fileUrl;
    link.download = "download";
    link.textContent = fileName || null;
    link.style.background = "black";
    link.style.color = "white";
    link.click();
    document.body.removeChild(link);
}
